/*
 * @Author: zhangsheng sheng10.zhang@epro.com.cn
 * @Date: 2025-09-05 10:35:24
 * @LastEditors: zhangsheng sheng10.zhang@epro.com.cn
 * @LastEditTime: 2025-09-12 17:37:36
 * @FilePath: \shopify-web\src\pages\csr-template\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import './index.less';

import { StoriesSwiper } from '../index-new/sections/index-stories/index'

$(document).ready(function() {
    
    if(window.innerWidth < 1024){
        // 仅移动端 轮播展示
        new StoriesSwiper()
    }
})

